// libraries
import React from 'react';
// styles & themes
import algoTheme from "./theme";

export const ThemeContext = React.createContext(algoTheme);

export default ThemeContext;